export default __webpack_public_path__ + "static/media/logo2.2b0c6bfa.png";